import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Avatar,
  Skeleton,
  Segmented,
  Drawer,
  Modal,
  Button,
} from "antd";
import {
  // RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { List, ListItem, ListSubheader } from "@mui/material";
import { API } from "aws-amplify";
import OtpInput from "react-otp-input";
import IconsList from "../../../common/IconsList";
import AppContext from "../../../../config/AppContext";
import { getAge } from "../../../../utilities/Utilities";
import defaultMale from "../../../../assets/images/defaultMale.png";
import defaultFemale from "../../../../assets/images/defaultFemale.png";
import SwitchOrg from "../../../common/SwitchOrg";

export default function UserProfileList(props) {
  const {
    loading,
    profileDetails,
    loginUserDetails,
    setfetchList,
    filterList,
    fetchUserInfo,
    getLoginUserInfo,
    getProfilesList,
    getCaregiverProfilesList,
    getProfileDetails,
    getMoreProfilesData,
    isLoadingMore,
  } = useContext(AppContext);

  const [tabValue, setTabValue] = useState("All Accounts");
  const firstResponderOptions = [`All Accounts`, `Accessible Accounts`];
  const caregiverOptions = [`Active Accounts`, `Inactive Accounts`];
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [accessAllProfiles, setAccessAllProfiles] = useState(true);
  const [transferAccessCode, setTransferAccessCode] = useState("");
  const [enableRequireAccessCode, setEnableRequireAccessCode] = useState(false);
  const [accessProfileInfo, setAccessProfileInfo] = useState(null);
  const [enableActiveProfile, setEnableActiveProfile] = useState(false);
  // const [isLoading, setLoading] = useState(true);

  const [modal, setModal] = useState(false);
  const [Popup, setPopup] = useState(false);
  const [search, setsearch] = useState("");
  const [saveUser, setsaveUser] = useState({});
  const [warningIconIndex, setwarningIconIndex] = useState(0);
  const [warningIconsList, setwarningIconsList] = useState([]);
  const [firstResponderNotes, setFirstResponderNotes] = useState("");
  const [warningIconsListHeading, setwarningIconsListHeading] = useState("");
  const [warningIconsInfo, setwarningIconsInfo] = useState("");
  const [profilesView, setprofilesView] = useState(true);
  const [accessCodes, setAccessCodes] = useState("");
  const [enableAccessDenied, setEnableAccessDenied] = useState(false);
  const [enableOptions, setEnableOptions] = useState(true);
  const [enableLoader, setEnableLoader] = useState(true);

  useEffect(() => {
    const { isMobile } = props;
    if (isMobile) {
      setIsMobileDevice(isMobile);
    }
  }, [props]);

  useEffect(() => {
    fetchUserInfo();
    if (loginUserDetails?.userProfile === "F") {
      setTabValue(`All Accounts`);
    } else {
      setTabValue(`Active Accounts`);
    }
  }, [loginUserDetails]);

  const responderNoWarningIcons = async (item) => {
    setModal(false);
    profileAccessCount(
      // accessLevelValue,
      item?.id,
      item?.orgId
    );
  };

  const openModal = async (item) => {
    setsaveUser(item);
    if (item?.userAccess === true) {
      setModal(true);
    }

    if (item?.warningAcknowledgmentTitle !== undefined) {
      setwarningIconsListHeading(item.warningAcknowledgmentTitle);
    } else {
      setwarningIconsListHeading("");
    }

    await API.get(
      "get",
      `/mobile/userWarningIconsAndProfilePercentage/${item?.id}/${item?.orgId}`,
      {}
    )
      .then((response) => {
        if (
          response?.firstResponderNotes !== undefined &&
          response?.firstResponderNotes !== null
        ) {
          setFirstResponderNotes(response?.firstResponderNotes);
        } else {
          setFirstResponderNotes("");
        }
        if (response?.warningIcons?.length > 0) {
          setwarningIconsList(response?.warningIcons);
        } else {
          responderNoWarningIcons(item);
        }
      })
      .catch((error) => {
        console.log(
          "Error: userWarningIconsAndProfilePercentage",
          error.response
        );
        responderNoWarningIcons(item);
      });
  };

  const sendRequest = () => {
    setEnableAccessDenied(true);
  };

  const searchFilterFunction = (text) => {
    const newData = filterList.filter((item) => {
      let itemData = ``;

      itemData = `
      ${item?.addIndivualData?.firstName + " "}
      ${item?.addIndivualData?.lastName}
      ${item?.addIndivualData?.birthDate}
      ${item?.contactInfo?.address}
      ${item?.contactInfo?.city}
      ${item?.contactInfo?.state}
      ${item?.contactInfo?.addaddress}
      `;

      if (
        item.currentContactInfo?.address !== undefined &&
        item.currentContactInfo?.address !== null &&
        item.currentContactInfo?.address !== ""
      ) {
        itemData = `
        ${itemData}
        ${item?.currentContactInfo?.address}
        ${item?.currentContactInfo?.city}
        ${item?.currentContactInfo?.state}
        ${item?.currentContactInfo?.addaddress}
        `;
      }

      if (
        item.currentContactInfo?.currentCell !== undefined &&
        item.currentContactInfo?.currentCell !== null &&
        item.currentContactInfo?.currentCell !== ""
      ) {
        itemData = `
        ${itemData}
        ${item?.currentContactInfo?.currentCell
          ?.toString()
          .replace(/[^\d]/g, "")}
        `;
      }

      if (
        item.currentContactInfo?.phone !== undefined &&
        item.currentContactInfo?.phone !== null &&
        item.currentContactInfo?.phone !== ""
      ) {
        itemData = `
        ${itemData}
        ${item?.currentContactInfo?.phone?.toString().replace(/[^\d]/g, "")}
        `;
      }

      if (
        item.contactInfo?.phone !== undefined &&
        item.contactInfo?.phone !== null &&
        item.contactInfo?.phone !== ""
      ) {
        itemData = `
        ${itemData}
        ${item?.contactInfo?.phone?.toString().replace(/[^\d]/g, "")}
        `;
      }

      const searchData = text?.toLowerCase();
      const textData = itemData?.toLowerCase();

      if (accessAllProfiles) {
        return textData?.indexOf(searchData) > -1;
      } else {
        if (item?.firstResponderAccess === true) {
          return textData?.indexOf(searchData) > -1;
        }
      }
    });
    setfetchList(newData);
  };

  const handleProfilesMenu = () => {
    props?.handleProfilesMenu();
  };

  const switchToProfile = async (
    userType,
    profileId,
    orgId,
    accessLevel,
    initialSetupComplete,
    isExpired,
    payment,
    profileFullInfo,
    isActive
  ) => {
    if (loginUserDetails?.isWebUser === true) {
      accessProfile(
        profileId,
        orgId,
        // accessLevelValue,
        initialSetupComplete,
        profileFullInfo
      );
    } else {
      if (!isActive) {
        setEnableActiveProfile(true);
      } else {
        if (payment) {
          if (profileFullInfo.isTrailPeriod === false) {
            if (isExpired && isActive) {
              // ('SubscriptionsScreen', {
              //   profileId: profileId,
              //   orgId: orgId,
              //   isExpired,
              //   payment,
              //   profileFullInfo,
              // });
              alert("Subscription Expired");
            } else {
              accessProfile(
                profileId,
                orgId,
                // accessLevelValue,
                initialSetupComplete,
                profileFullInfo
              );
            }
          } else {
            accessProfile(
              profileId,
              orgId,
              // accessLevelValue,
              initialSetupComplete,
              profileFullInfo
            );
          }
        } else {
          accessProfile(
            profileId,
            orgId,
            // accessLevelValue,
            initialSetupComplete,
            profileFullInfo
          );
        }
      }
    }
  };

  const accessProfile = (
    profileId,
    orgId,
    // accessLevelValue,
    initialSetupComplete,
    profileFullInfo
  ) => {
    if (
      profileFullInfo?.userProfile === "SN" &&
      profileFullInfo?.addIndivualData?.requireTransferAccessCode === true &&
      profileFullInfo?.addIndivualData?.transferAccessCode !== undefined &&
      profileFullInfo?.addIndivualData?.transferAccessCode !== ""
    ) {
      setEnableRequireAccessCode(true);
      setAccessProfileInfo({
        transferAccessCode:
          profileFullInfo?.addIndivualData?.transferAccessCode,
        profileId: profileId,
        orgId: profileFullInfo?.orgId,
        // accessLevelValue: accessLevelValue,
      });
    } else {
      setEnableRequireAccessCode(false);
      setAccessProfileInfo(null);
      if (initialSetupComplete === undefined || initialSetupComplete === true) {
        profileAccessCount(
          // accessLevelValue,
          profileId,
          orgId
        );
      } else {
        // let fName =
        //   profileFullInfo?.addIndivualData?.firstName !== "" &&
        //   profileFullInfo?.addIndivualData?.firstName !== null &&
        //   profileFullInfo?.addIndivualData?.firstName !== undefined
        //     ? profileFullInfo?.addIndivualData?.firstName
        //     : "";
        // let lName =
        //   profileFullInfo?.addIndivualData?.lastName !== "" &&
        //   profileFullInfo?.addIndivualData?.lastName !== null &&
        //   profileFullInfo?.addIndivualData?.lastName !== undefined
        //     ? profileFullInfo?.addIndivualData?.lastName
        //     : "";

        // ('ContactInfoScreen', {
        //   profileId: profileId,
        //   orgId: orgId,
        //   profileFirstName: fName,
        //   profileLastName: lName,
        // });

        // temp added
        profileAccessCount(
          // accessLevelValue,
          profileId,
          orgId
        );
      }
    }
  };

  const profileAccessCount = async (
    // accessLevelValue,
    profileId,
    orgId
  ) => {
    let loginUserId = loginUserDetails?.id;
    await API.put(
      "put",
      `/mobile/update/loginCount/${loginUserId}/${profileId}`,
      {}
    )
      .then((res) => {
        setsaveUser({});
        getProfileDetails(profileId, orgId);
      })
      .catch((error) => {
        console.log("Error access count:", error.response);
        setsaveUser({});
        getProfileDetails(profileId, orgId);
      });
  };

  const closeProfile = () => {
    setEnableRequireAccessCode(false);
    setAccessProfileInfo(null);
    setTransferAccessCode("");
  };

  const viewProfile = () => {
    if (transferAccessCode !== accessProfileInfo?.transferAccessCode) {
      alert("Enter valid access code");
    } else {
      setEnableRequireAccessCode(false);
      setAccessProfileInfo(null);
      setTransferAccessCode("");
      profileAccessCount(
        // accessProfileInfo?.accessLevelValue,
        accessProfileInfo?.profileId,
        accessProfileInfo?.orgId
      );
    }
  };

  const activateAccount = async () => {
    let loginUserId = loginUserDetails?.id;
    setEnableActiveProfile(false);
    // setLoading(true);

    await API.put("put", `/mobile/changeCaregiverStatus/${loginUserId}`, {
      body: {
        entityData: {
          profileIds: accessProfileInfo?.profileId,
          caregiverStatus: true,
        },
      },
    })
      .then((response) => {
        getLoginUserInfo();
      })
      .catch((error) => {
        console.log("Error:Account Active", error);
        alert("Something went wrong!");
        // setLoading(false);
      });
  };

  const ShowUserProfiles = (profilesList) => {
    return (
      <div>
        {profilesList?.length > 0 ? (
          <div>
            {profilesList.map((profile, index) => (
              <React.Fragment key={index}>
                <ListItem
                  disableGutters
                  disablePadding
                  style={{ paddingTop: "5px" }}
                >
                  <Col span={24} style={{ padding: "5px 10px 0px" }}>
                    <Skeleton avatar title={false} loading={loading} active>
                      <Card
                        className="card-container"
                        hoverable
                        bodyStyle={{ padding: "10px" }}
                        style={{
                          margin: "0px",
                          border:
                            profileDetails?.id === profile?.id
                              ? "2px solid #6a347d"
                              : null,
                        }}
                        onClick={() => {
                          if (isMobileDevice) {
                            handleProfilesMenu();
                          }

                          if (
                            loginUserDetails?.userProfile === "F" &&
                            loginUserDetails?.isWebUser !== true
                          ) {
                            profile?.userAccess == false
                              ? sendRequest()
                              : openModal(profile);
                          } else {
                            switchToProfile(
                              profile.userProfile,
                              profile.id,
                              profile.orgId,
                              profile.accessLevel,
                              profile.initialSetupComplete,
                              profile.isExpired,
                              profile.payment,
                              profile,
                              profile.isActive
                            );
                          }

                          // getProfileDetails(profile?.id, profile?.orgId);
                        }}
                      >
                        <Row gutter={[32, 32]} justify="space-between">
                          <Col>
                            <Row gutter={[8, 8]}>
                              <Col>
                                {profile?.securedFileUrl ? (
                                  <Avatar
                                    size={72}
                                    src={profile?.securedFileUrl}
                                  />
                                ) : profile?.addIndivualData?.firstName ? (
                                  <Avatar
                                    size={72}
                                    style={{ background: "#d5d5d5" }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "36px",
                                        color: "#333",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {profile?.addIndivualData?.firstName?.charAt(
                                        0
                                      )}
                                    </span>
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    size={72}
                                    src={
                                      profile?.addIndivualData?.gender ===
                                      "Female"
                                        ? defaultFemale
                                        : defaultMale
                                    }
                                  />
                                )}
                              </Col>
                              <Col>
                                <div>
                                  <span
                                    style={{
                                      fontSize: "18px",
                                      textTransform: "capitalize",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {profile.addIndivualData?.firstName +
                                      " " +
                                      profile.addIndivualData?.lastName}
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    <span style={{ fontWeight: "normal" }}>
                                      {profile?.addIndivualData?.birthDate &&
                                        getAge(
                                          profile.addIndivualData.birthDate
                                        )}{" "}
                                      {" Year(s)"}
                                    </span>{" "}
                                    <span style={{ fontWeight: "lighter" }}>
                                      ({" "}
                                      {profile?.addIndivualData?.birthDate ||
                                        ""}{" "}
                                      )
                                    </span>
                                  </span>
                                </div>
                                <div>
                                  <span style={{ fontWeight: "lighter" }}>
                                    {profile?.contactInfo?.city || "N/A"}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Col>

                          {/* <Col>
                            <Row justify={"center"} align={"middle"}>
                              <RightOutlined
                                style={{ fontSize: "16px", marginTop: "28px" }}
                              />
                            </Row>
                          </Col> */}
                        </Row>
                      </Card>
                    </Skeleton>
                  </Col>
                </ListItem>
              </React.Fragment>
            ))}
          </div>
        ) : (
          <div>
            <h2 style={{ textAlign: "center", padding: "15px 10px 10px" }}>
              Profiles Not Found
            </h2>
          </div>
        )}
      </div>
    );
  };

  const userProfiles = (action) => {
    return (
      <List>
        <div
          style={{
            backgroundColor: "#f5f5f5",
            paddingBottom: "10px",
            minHeight: "100vh",
            borderRadius: "5px",
          }}
        >
          <ListSubheader sx={{ bgcolor: "background.paper", pb: 2 }}>
            <div style={{ marginTop: "-20px", paddingTop: "5px" }}>
              <Input
                allowClear
                placeholder="Search by name, phone, birth date, city"
                onChange={(e) => searchFilterFunction(e.target.value)}
                prefix={<SearchOutlined />}
                className="searchtext-input"
              />
            </div>
          </ListSubheader>

          {loginUserDetails?.userProfile === "F"
            ? ShowUserProfiles(getProfilesList(action))
            : ShowUserProfiles(getCaregiverProfilesList(action))}
        </div>
      </List>
    );
  };

  return (
    <Card
      className="card-container"
      style={{
        borderRadius: "0px",
      }}
    >
      <div style={{ minHeight: "100vh" }}>
        <div style={{ marginBottom: "10px" }}>
          <SwitchOrg />
        </div>

        <Segmented
          block
          size="large"
          options={
            loginUserDetails?.userProfile === "F"
              ? firstResponderOptions
              : caregiverOptions
          }
          value={tabValue}
          onChange={(value) => {
            setTabValue(value);
            if (value === `All Accounts` || value === `Active Accounts`) {
              setAccessAllProfiles(true);
            } else {
              setAccessAllProfiles(false);
            }
          }}
          defaultValue={
            loginUserDetails?.userProfile === "F"
              ? `All Accounts`
              : `Active Accounts`
          }
        />

        <div style={{ marginTop: "20px" }}>
          {tabValue === `All Accounts` || tabValue === `Active Accounts`
            ? userProfiles(true)
            : userProfiles(false)}
        </div>

        {isLoadingMore && (
          <Row justify={"center"}>
            <span
              style={{
                fontSize: "18px",
                textAlign: "center",
                marginTop: "5px",
                cursor: "pointer",
                color: "#6a347d",
                textDecoration: "underline",
                fontWeight: "normal",
              }}
              onClick={() => getMoreProfilesData()}
            >
              Load More
            </span>
          </Row>
        )}
      </div>

      <Drawer
        title={"Access Code"}
        placement="right"
        onClose={() => closeProfile()}
        open={enableRequireAccessCode}
        width={"100%"}
        bodyStyle={{ background: "#f5f5f5" }}
      >
        <Row justify={"center"} style={{ marginTop: "10%" }}>
          <Card className="card-container">
            <h3 style={{ textAlign: "center", fontSize: "25px" }}>
              An access code is required to access this profile.
            </h3>
            <p style={{ textAlign: "center", fontSize: "18px" }}></p>

            <div style={{ marginBottom: "20px" }}>
              <Row justify={"center"}>
                <OtpInput
                  value={transferAccessCode}
                  onChange={setTransferAccessCode}
                  numInputs={6}
                  renderSeparator={<span style={{ width: "20px" }}></span>}
                  renderInput={(props) => (
                    <input
                      {...props}
                      style={{
                        height: "50px",
                        width: "40px",
                        fontSize: "24px",
                        fontWeight: "bold",
                        textAlign: "center",
                        borderRadius: "5px",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  )}
                />
              </Row>
            </div>

            <Row gutter={[16, 16]}>
              <Col
                xxl={{ span: 12 }}
                xl={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <Button
                  onClick={() => closeProfile()}
                  style={{
                    height: "50px",
                    width: "100%",
                  }}
                >
                  Cancel
                </Button>
              </Col>

              <Col
                xxl={{ span: 12 }}
                xl={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <Button
                  onClick={() => viewProfile()}
                  style={{
                    background: "#6A347D",
                    color: "white",
                    height: "50px",
                    width: "100%",
                  }}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Card>
        </Row>
      </Drawer>

      <Modal
        closeIcon={false}
        title={null}
        open={enableAccessDenied}
        footer={null}
        style={{ marginTop: "5%", padding: "30px" }}
      >
        <Row justify={"center"}>
          <div style={{ margin: "20px" }}>
            <h2
              style={{
                textAlign: "center",
                color: "tomato",
                fontWeight: "bold",
              }}
            >
              We're Sorry!
            </h2>
            <h3 style={{ textAlign: "center", color: "tomato" }}>
              You do not have permission to access this account.
            </h3>
            <h4>
              Steps for the caregiver to allow First Responder access to this
              account:
            </h4>
            <p style={{ color: "#555" }}>1. Access the account</p>
            <p style={{ color: "#555" }}>2. Select 'Support Network'</p>
            <p style={{ color: "#555" }}>
              3. Set 'Allow First Responders Access' to 'On' (green)
            </p>
          </div>
        </Row>
        <Row justify={"center"}>
          <Button
            style={{
              background: "#6A347D",
              color: "white",
              height: "50px",
              width: "100%",
              margin: "20px",
            }}
            onClick={() => setEnableAccessDenied(false)}
          >
            Okay
          </Button>
        </Row>
      </Modal>

      <Modal
        title={
          warningIconsListHeading !== undefined &&
          warningIconsListHeading !== null &&
          warningIconsListHeading !== "" ? (
            <p style={{ textAlign: "center", color: "tomato", margin: "0px" }}>
              {warningIconsListHeading}
            </p>
          ) : null
        }
        open={modal}
        footer={null}
        closable={false}
        style={{ marginTop: "5%", padding: "30px" }}
      >
        <Row justify={"center"}>
          <IconsList
            firstResponderNotes={firstResponderNotes}
            warningIcons={warningIconsList}
            warningIconsInfo={warningIconsList[0]}
            handleClose={() => setModal(false)}
          />
        </Row>
        <Row justify={"center"}>
          <Button
            style={{
              background: "#6A347D",
              color: "white",
              height: "50px",
              width: "100%",
              margin: "20px",
            }}
            onClick={() => responderNoWarningIcons(saveUser)}
          >
            Acknowledge
          </Button>
        </Row>
      </Modal>

      <Modal
        title="Confirmation"
        open={enableActiveProfile}
        onOk={() => null}
        onCancel={() => null}
        footer={null}
        style={{ marginTop: "10%", padding: "30px" }}
      >
        <Row justify={"center"}>
          <Card className="card-container">
            <h3 style={{ textAlign: "center", fontSize: "25px" }}>
              Are you sure you want to<br></br>RE-ACTIVATE your user account?
            </h3>
            <p style={{ textAlign: "center", fontSize: "18px" }}></p>

            <Row gutter={[16, 16]}>
              <Col
                xxl={{ span: 12 }}
                xl={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <Button
                  onClick={() => setEnableActiveProfile(false)}
                  style={{
                    height: "50px",
                    width: "100%",
                  }}
                >
                  No
                </Button>
              </Col>

              <Col
                xxl={{ span: 12 }}
                xl={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <Button
                  onClick={() => activateAccount()}
                  style={{
                    background: "#6A347D",
                    color: "white",
                    height: "50px",
                    width: "100%",
                  }}
                >
                  Yes
                </Button>
              </Col>
            </Row>
          </Card>
        </Row>
      </Modal>
    </Card>
  );
}
